import { 
  UserWatchlistHeader, 
  CreateWatchlistSection, 
  UserWatchlistsGrid
} from '@/components/watchlists'

export function WatchlistsPage() {
  return (
    <div className="space-y-6">
      <UserWatchlistHeader />
      <CreateWatchlistSection />
      <UserWatchlistsGrid />
    </div>
  )
} 